import * as form from '../form';

export const substanceDrugNegativeImpact = (data = {}) => ({
  HasNegativeImpact: form.branch(data.HasNegativeImpact),
  NegativeImpactExplanation: form.textarea(data.NegativeImpactExplanation),
  NegativeImpactDates: form.daterange(data.NegativeImpactDates),
});
